import type { LoginCountry as SelectedLoginCountry } from '@shared/config/auth'

export {
  isJpFunnelDestination,
  LOGIN_COUNTRY_COOKIE_KEY,
  loginCountrySchema,
  parseLoginCountry,
  resolveLoginIpRegion,
  shouldRequestLoginCountry,
  shouldShowCountrySelection,
  type LoginCountry,
  type LoginIpRegion,
} from '@shared/config/auth'

type AuthEntrySearchParams = {
  destination: string
  source?: string
  countrySelectionCompleted?: boolean
  selectedCountry?: SelectedLoginCountry
  additionalParams?: Record<string, string | undefined>
}

const buildAuthEntryUrl = (
  pathname: string,
  { destination, source, countrySelectionCompleted, selectedCountry, additionalParams }: AuthEntrySearchParams,
): string => {
  const searchParams = new URLSearchParams({ destination })
  if (source) {
    searchParams.set('source', source)
  }
  if (countrySelectionCompleted) {
    searchParams.set('countrySelected', 'true')
  }
  if (countrySelectionCompleted && selectedCountry) {
    searchParams.set('country', selectedCountry)
  }
  Object.entries(additionalParams ?? {}).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value)
    }
  })

  return `${pathname}?${searchParams.toString()}`
}

export const buildCountrySelectUrl = (params: AuthEntrySearchParams): string =>
  buildAuthEntryUrl('/country-select', params)

export const buildLoginUrl = (params: AuthEntrySearchParams): string => buildAuthEntryUrl('/login', params)
